<div class="prompt-library-popup" (clickOutside)="closePopup()">
  <div class="prompt-header sticky-header">
    <div class="prompt-header-left">
      <span>{{ "PROMPT_LIBRARY_BUTTON" | translate }}</span>
      <ng-container *ngIf="showRegRadarStaticHeaders">
        <span class="pipe-separator">|</span>
        <div class="tooltip-container" *ngIf = "isRegRader">
          <img src="../../../assets/icons/icon-regradar.svg" alt="Reg Radar Icon" class="reg-radar-icon" />
          <span class="reg-radar-text">{{ "REG_RADAR_TITLE" | translate }}</span>
          <img src="../../../assets/icons/info-circle.svg" alt="infoIcon" class="info-icon" />
          <div class="custom-tooltip reg-radar-tooltip">
            {{ "REG_RADAR_QUESTIONS_TOOLTIP" | translate }}
          </div>
        </div>
        <!-- Static -->
        <div class="tooltip-container" *ngIf = "isRegSelect">
          <img src="../../../assets/icons/icon-expert-curated-questions.svg" alt="Expert Curated Questions Icon" class="static-icon" />
          <span class="static-text">{{ "EXPERT_CURATED_QUESTIONS_TITLE" | translate }}</span>
          <img src="../../../assets/icons/info-circle.svg" alt="infoIcon" class="info-icon" />
          <div class="custom-tooltip static-tooltip">
            {{ "EXPERT_CURATED_QUESTIONS_TOOLTIP" | translate }}
          </div>
        </div>
      </ng-container>
    </div>
    <button class="close-btn" (click)="closePopup()">✕</button>
  </div>

  <div class="tag-container sticky-header" *ngIf="!isAgent">
    <button *ngFor="let tag of vectorDbDatasets"
            [class.active]="toggledDbDataset.name === tag.name"
            (click)="selectTag(tag)">
      {{ tag.name | translate }}
    </button>
  </div>

  <div class="question-scroll-area">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="prompt-library-loading">
      <div class="loading-message">
        <span class="loading-text">{{ 'PROMPT_LIBRARY_FETCHING_QUESTIONS' | translate }}</span>
      </div>
      
      <!-- Skeletal loader items -->
      <div class="skeleton-question-item" *ngFor="let item of [1,2,3,4,5]">
        <div class="skeleton-icon"></div>
        <div class="skeleton-text-content">
          <div class="skeleton skeleton-text skeleton-line-1"></div>
          <div class="skeleton skeleton-text skeleton-line-2"></div>
        </div>
        <div class="skeleton-actions" *ngIf="!isAgent">
          <div class="skeleton skeleton-icon-button"></div>
          <div class="skeleton skeleton-icon-button"></div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && !hasQuestions" class="empty-state">
      <div class="empty-state-icon">
        <i class="fas fa-exclamation-circle"></i>
      </div>
      <div class="empty-state-content">
        <h3 class="empty-state-title">{{ 'PROMPT_LIBRARY_NO_QUESTIONS_FOUND' | translate }}</h3>
        <p class="empty-state-message">{{ 'PROMPT_LIBRARY_CONTACT_SUPPORT' | translate }}</p>
      </div>
    </div>

    <!-- Actual Questions -->
    <ng-container *ngIf="!isLoading && hasQuestions">
      <ng-container *ngFor="let type of ['regRadar', 'static']">
        <div *ngFor="let q of filterQuestionsDictionary[type]; let i = index"
             class="question-item question-{{type}}-{{i}}"
             [class.highlight]="highlightedQuestion?.type === type && highlightedQuestion?.index === i">
    
          <!-- Icon -->
          <div *ngIf="showRegRadarStaticHeaders">
            <div *ngIf="type === 'regRadar'" class="reg-radar-icon-container">
              <img src="../../../assets/icons/icon-regradar.svg" alt="Reg Radar Icon" class="reg-radar-icon" />
            </div>
            <div *ngIf="type === 'static'" class="static-icon-container">
              <img src="../../../assets/icons/icon-expert-curated-questions.svg" alt="Expert Curated Questions Icon" class="static-icon" />
            </div>
          </div>
          <!-- Question text clickable -->
          <button class="question-text-btn"
                  (click)="uploadQuestion(
                    currentLanguage === 'jp' ? q.QuestionJP :
                    currentLanguage === 'zhCN' ? q.QuestionCN :
                    q.Question
                  )">
            {{
              ((currentLanguage === 'jp' ? q.QuestionJP : currentLanguage === 'zhCN' ? q.QuestionCN : q.Question) || q.Question) | translate
            }}
          </button>
    
          <!-- Actions -->
          <div class="question-icons" *ngIf="!isAgent">
            <i class="fas"
               [ngClass]="copiedIndex === i ? 'fa-check copied-icon' : 'fa-copy copy-icon'"
               (click)="copyQuestion(
                 currentLanguage === 'jp' ? q.QuestionJP :
                 currentLanguage === 'zhCN' ? q.QuestionCN :
                 q.Question, i)">
            </i>
    
            <div [ngClass]="{'disabled-upload-icon': loaderShow || IsResponseStreaming}" 
                 class="upload-icon-wrapper"
                 [class.disabled]="loaderShow || IsResponseStreaming"
                 (click)="!loaderShow && !IsResponseStreaming ? uploadQuestion(
                   currentLanguage === 'jp' ? q.QuestionJP :
                   currentLanguage === 'zhCN' ? q.QuestionCN :
                   q.Question
                 ) : null">
              <i class="fas fa-arrow-up upload-icon"></i>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>    
  </div>
</div>
